import { path, pathEq, compose, when, includes } from "ramda"
import { localized, localizedF } from "js/includes/common/utils"

export const hasWampError = pathEq(["args", 0], "ERROR")
export const wampLiveIsDisabled = pathEq(["args", 0], "DISABLED")

const ignorableWampErrors = ["wamp.error.no_such_procedure", "wamp.error.canceled"]

export function isReportableWampException(error) {
  const reportableWampException = !ignorableWampErrors.includes(error?.error) && error?.name !== "SESSION ERROR"
  if (!reportableWampException) {
    console.log("Wamp exception marked as non reportable:", error)
  }
  return reportableWampException
}

export const getLocalizedWampError = error => {
  if (error?.error === "wamp.error.no_such_procedure") {
    switch (window?.controller?.attributes?.activeTab?.attributes?.subTab?.attributes?.type) {
      case "DeviceRemoteToolsTabModel":
        return localized("remoteTools.unavailable")
      default:
        return localized("general.error")
    }
  } else {
    return compose(
      when(includes("<<"), localizedF("general.error")),
      error => localized(`wampErrors.${error}`),
      path(["args", 1]),
    )(error)
  }
}
